// components
import { Icon } from '@sdb/planning-ui';

// styles
import { PopoverContextBox } from '../../Popover.styles';
import { ActionSetContainer } from './PopoverActionSet.styles';
import { IconContainer } from 'components/mrp/mrp.styles';
import {
  DisplayWrapper,
  IconWrapper,
  TailWrapper
} from '../PopoverAction/PopoverAction.styles';

// types
import { PopoverActionSetProps } from './PopoverActionSet.types';

// libs
import { cloneElement, useRef, useState } from 'react';

const PopoverActionSet = ({
  value,
  children,
  icon,
  forceIconSpace
}: PopoverActionSetProps) => {
  const [applyOffsetX, setApplyOffsetX] = useState(false);
  const [applyOffsetY, setApplyOffsetY] = useState(false);

  const [showSubEl, setShowSubEl] = useState(false);

  const subRef = useRef<HTMLElement | null>(null);
  const subEl = cloneElement(
    <PopoverContextBox
      sx={{
        visibility: showSubEl ? 'default' : 'hidden'
      }}
      className={`subActions ${applyOffsetX ? 'escaping-horizontal' : ''} ${
        applyOffsetY ? 'escaping-vertical' : ''
      }`}
    >
      {children}
    </PopoverContextBox>,
    {
      ref: (node: HTMLElement | null) => (subRef.current = node)
    }
  );
  const calculateOffsetRequirement = () => {
    if (
      subRef.current?.classList.contains('escaping-horizontal') ||
      subRef.current?.classList.contains('escaping-vertical')
    )
      return;

    const subRightBound = subRef.current?.getBoundingClientRect().right || 0;
    setApplyOffsetX(subRightBound > window.innerWidth);

    const subBottomBound = subRef.current?.getBoundingClientRect().bottom || 0;
    setApplyOffsetY(subBottomBound > window.innerHeight);
  };

  return (
    <ActionSetContainer
      variant="text"
      onMouseEnter={() => {
        calculateOffsetRequirement();
        setShowSubEl(true);
      }}
      onMouseLeave={() => setShowSubEl(false)}
    >
      {(icon || forceIconSpace) && (
        <IconWrapper>
          {icon && (
            <IconContainer iconSize="SMALL" iconColor={icon.iconColor}>
              <Icon type={icon.iconType} />
            </IconContainer>
          )}
        </IconWrapper>
      )}

      <DisplayWrapper>{value}</DisplayWrapper>

      <TailWrapper>
        <IconContainer iconSize="SMALL">
          <Icon type="chevron-right" />
        </IconContainer>
      </TailWrapper>

      {subEl}
    </ActionSetContainer>
  );
};

export default PopoverActionSet;
